import { storyblokEditable } from "gatsby-source-storyblok"

import TextInfoCard from "../../../../../V2/Cards/Content/Info/TextInfo"

import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokTextInfoCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.TextInfoCard>) => {
  return (
    <TextInfoCard
      backgroundColor={blok.backgroundColor}
      titleColor={blok.titleColor}
      borderColor={blok.borderColor}
      headerText={blok.headerText}
      superscriptText={blok.superscriptText}
      subscriptText={blok.subscriptText}
      linkText={blok.ctaText}
      linkUrl={storyblokLinkToYocoLink(blok.ctaLink)}
      linkColor={blok.ctaColor}
      bodyText={blok.bodyText}
      disclaimerText={blok.disclaimerText}
      disclaimerBackgroundColor={blok.disclaimerBackgroundColor}
      size={blok.size}
      textAlignment={blok.textAlignment}
      mobileGridOrder={mobileGridOrder}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokTextInfoCard
